import type { BoxProps } from '@hover/blueprint';
import {
  Body,
  Box,
  Container,
  Heading,
  calc,
  cssVariables,
} from '@hover/blueprint';
import React from 'react';

import { hideScrollbars } from 'src/shared/helpers/styles';

const BoxHideScroll = hideScrollbars(Box);
export const PROJECT_DETAILS_PADDING = { base: 500, tablet: 800 };

export const HeaderSection = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) => (
  <Box flexDir="column" px={PROJECT_DETAILS_PADDING}>
    <Heading mb={0} mr={100} mt={0} size={100}>
      {title}
    </Heading>
    {subtitle && (
      <Body color="neutral.600" mb={500} mt={0} size={300}>
        {subtitle}
      </Body>
    )}
  </Box>
);

interface ProjectCardSectionProps extends BoxProps {
  children: React.ReactNode;
}

export const ProjectCardSection = ({
  children,
  ...props
}: ProjectCardSectionProps) => (
  <BoxHideScroll
    flexWrap={{ tablet: 'wrap' }}
    gap={{ base: 200, tablet: 300 }}
    mt="0px !important"
    overflow={{ base: 'auto', tablet: 'hidden' }}
    px={PROJECT_DETAILS_PADDING}
    scrollSnapType="x mandatory"
    width="100%"
    {...props}
  >
    {children}
  </BoxHideScroll>
);

export const ProjectCardWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const widthProps = {
    base: '100%',
    tablet: calc.subtract('50%', calc.divide(cssVariables.space(300), 2)),
  };
  return (
    <Container m={0} minWidth={widthProps} p={0} width={widthProps}>
      {children}
    </Container>
  );
};
